import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { BbitI18n } from '@bbitgmbh/bbit.utils';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { MonthNavigatorComponent } from '../../month-navigator/month-navigator.component';
import { DatePickerOverlayRef } from './date-picker-overlay-ref';

@Component({
  selector: 'bbit-date-picker-overlay',
  templateUrl: './date-picker-overlay.component.html',
  styleUrls: ['./date-picker-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MonthNavigatorComponent, AsyncPipe],
})
export class DatePickerOverlayComponent {
  public date: BehaviorSubject<DateTime>;
  public timezone = BbitI18n.getTimezone();

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  public constructor(private _ref: DatePickerOverlayRef) {
    this.date = this._ref.getDate();
    this.timezone = this._ref.getTimezone();
  }

  public setDate(date: DateTime): void {
    this._ref.dateChangedSubject.next(date);
  }
}
